export function atobPolyfill(base64Input: string): string {
  const chars =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
  let result = "";

  const sanitized = base64Input.replace(/=+$/, "");

  if (sanitized.length % 4 === 1) {
    throw new Error("'atobPolyfill' falhou: base64 inválido.");
  }

  for (let i = 0; i < sanitized.length; i += 4) {
    const c1 = chars.indexOf(sanitized.charAt(i));
    const c2 = chars.indexOf(sanitized.charAt(i + 1));
    const c3 = chars.indexOf(sanitized.charAt(i + 2));
    const c4 = chars.indexOf(sanitized.charAt(i + 3));

    const n =
      c1 * 2 ** 18 +
      c2 * 2 ** 12 +
      (c3 >= 0 ? c3 * 2 ** 6 : 0) +
      (c4 >= 0 ? c4 : 0);

    if (c3 === -1) {
      const byte1 = Math.floor(n / 2 ** 16) % 256;
      result += String.fromCharCode(byte1);
    } else if (c4 === -1) {
      const byte1 = Math.floor(n / 2 ** 16) % 256;
      const byte2 = Math.floor(n / 2 ** 8) % 256;
      result += String.fromCharCode(byte1, byte2);
    } else {
      const byte1 = Math.floor(n / 2 ** 16) % 256;
      const byte2 = Math.floor(n / 2 ** 8) % 256;
      const byte3 = n % 256;
      result += String.fromCharCode(byte1, byte2, byte3);
    }
  }

  return result;
}
